module.exports = __webpack_public_path__ + "09b5dfe427fbd8f5303d1a26c2cfabf1.jpg";